import {Helmet} from "react-helmet-async";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {RUMList} from "@/pages/rum/v2/list/RUMList.tsx";
import {RUMListActionsBar} from "@/pages/rum/v2/RUMListActionsBar.tsx";

export const RUMPage = () => {
  /* as in jackson */
  const {user} = useCurrentUserContext();
  return (
    <ContentContainer title="Real User Monitoring Checks" actionsBar={user?.has_write_access && <RUMListActionsBar />}>
      <Helmet>
        <title>Real User Monitoring Checks (v2)</title>
      </Helmet>
      <UpErrorBoundary>
        <RUMList />
      </UpErrorBoundary>
    </ContentContainer>
  );
};
